<script>
  import SelectInput from "@/components/atoms/SelectInput.vue";
  import ButtonIcon from "@/components/atoms/ButtonIcon.vue";
  import ToggleInput from "@/components/atoms/ToggleInput.vue";
  import AtomStatusPill from "@/components/atoms/AtomStatusPill.vue";
  import StarsRatingInput from "../atoms/StarsRatingInput.vue";

  export default {
    name: "RoomField",
    components: { SelectInput, ButtonIcon, ToggleInput, AtomStatusPill, StarsRatingInput },
    props: {
      rooms: { type: Array, required: true },
      value: { type: Object, default: null },
      enabled: { type: Boolean, default: true },
      inOperation: { type: Boolean, default: true },
      disabled: { type: Boolean, default: false },
      editorOpen: { type: Boolean, default: false },
      editorMode: { type: String, default: null },
    },
    computed: {
      canEdit() {
        return !!(this.value && (this.value._id || this.value.roomName));
      },
      selectValue() {
        if (!this.value) return "";
        return this.value._id || this.value.roomName || "";
      },

      isCreateLocked() {
        return this.editorOpen && this.editorMode === "create";
      },
      isEditLocked() {
        return this.editorOpen && this.editorMode === "edit";
      },

      addBtnClass() {
        return this.isCreateLocked ? "room-field__btn--edit" : "room-field__btn--add";
      },
      editBtnClass() {
        if (!this.canEdit || this.isEditLocked) return "room-field__btn--edit";
        return "room-field__btn--add";
      },

      isAddDisabled() {
        return this.disabled || this.isCreateLocked;
      },
      isEditDisabled() {
        return !this.canEdit || this.disabled || this.isEditLocked;
      },
      roomTypeMeta() {
        const types = Array.isArray(this.value?.platformType) ? this.value.platformType : [];

        if (types.length === 0) {
          return { label: "Not Found", variant: "unset" };
        }

        const map = {
          free: { label: "Free", variant: "free" },
          private: { label: "Privada", variant: "private" },
          group: { label: "Grupal", variant: "group" },
          both: { label: "Free / Priv", variant: "both" },
        };

        if (types.length === 1) {
          return map[types[0]] || { label: "Not Found", variant: "unset" };
        }

        if (types.length === 2 && types.includes("free") && types.includes("private")) {
          return map["both"];
        }

        return { label: "Not Found", variant: "unset" };
      },
    },
    methods: {
      onChange(val) {
        this.$emit("select", val);
      },
      onToggleEnable(val) {
        this.$emit("update:enabled", val);
      },
      onToggleOperation(val) {
        this.$emit("update:inOperation", val);
      },
      onAdd() {
        this.$emit("add");
      },
      onEdit() {
        this.$emit("edit");
      },
    },
  };
</script>

<template>
  <div class="room-field">
    <label class="room-field__label">Habitación</label>

    <div class="room-field__row">
      <SelectInput class="room-field__select" :options="rooms" :value="selectValue" :disabled="disabled" @input="onChange" />
      <ButtonIcon class="room-field__btn" :class="addBtnClass" icon="fas fa-plus" :disabled="isAddDisabled" @click="onAdd" />
      <ButtonIcon class="room-field__btn" :class="editBtnClass" icon="fas fa-pencil-alt" :disabled="isEditDisabled" @click="onEdit" />
    </div>

    <div v-if="value" class="room-field__toggles">
      <ToggleInput :value="enabled" label="Habilitada" @input="onToggleEnable" :disabled="isAddDisabled" />
      <ToggleInput :value="inOperation" label="En operación" @input="onToggleOperation" :disabled="isAddDisabled" />
      <AtomStatusPill :label="roomTypeMeta.label" :variant="roomTypeMeta.variant" />
      <StarsRatingInput class="room-field__qualification" :value="Number(value.qualification)" :disabled="true" title="Calificación" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .room-field {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;

    &__label {
      font-family: $newFont_medium;
      font-size: 16px;
      margin-bottom: 4px;
      color: #3d3d3d;
    }
    &__row {
      display: flex;
      align-items: center;
      gap: 12px;
    }
    &__select {
      flex: 1;
    }
    &__btn {
      border-radius: 8px;
      transition: all ease-in 0.2s;
      &--add {
        background: #bd0909;
      }
      &--edit {
        background: #c3c3c3;
      }
    }
    &__toggles {
      margin-top: 8px;
      display: flex;
      gap: 16px;
    }
    &__qualification {
      line-height: 1;
      cursor: default;
    }
  }
</style>
